document.addEventListener("DOMContentLoaded", function () {
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("start-animation");
      } else {
        entry.target.classList.remove("start-animation");
      }
    });
  });

  document.querySelectorAll(".anim-onscreen").forEach(function (animElement) {
    observer.observe(animElement);
  });

  let carousel = document.querySelector(".product-media__carousel");
  let zoomButton = document.querySelector(".product-media__zoom-button");

  if (carousel && zoomButton) {
    carousel.addEventListener("click", function () {
      zoomButton.click();
    });
  }

  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-inview');
      } else {
        entry.target.classList.remove('is-inview');
      }
    }
  }, { threshold: 0.01 });

  document.querySelectorAll('.impact-bar, impact-bar').forEach(el => io.observe(el));
  /*Flickity.defaults.dragThreshold = 7;

  (function () {
    var touchingCarousel = false,
      touchStartCoords;
    document.body.addEventListener("touchstart", function (e) {
      if (e.target.closest(".flickity-slider")) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY,
      };
    });
    document.body.addEventListener(
      "touchmove",
      function (e) {
        if (!(touchingCarousel && e.cancelable)) {
          return;
        }

        var moveVector = {
          x: e.touches[0].pageX - touchStartCoords.x,
          y: e.touches[0].pageY - touchStartCoords.y,
        };
        if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold)
          e.preventDefault();
      },
      {
        passive: false,
      }
    );
  })();*/

});

/*function handleChange(select, key) {
  const value = select.value;
  sessionStorage.setItem(key, value);
  document.querySelector('input[name="attributes[' + key + ']"]').value = value;
}

function setUpSamples() {
  const form = document.querySelector(".cart-drawer__footer");

  if (!form) return;

  const reversedSelects = [
    ...document.querySelectorAll(".sample-select"),
  ].reverse();

  reversedSelects.forEach((select, index) => {
    const productTitle = select.getAttribute('data-product-title');
    const key = `Sample-${index + 1}-for-${productTitle}`;

    const savedValue = sessionStorage.getItem(key);
    if (savedValue) select.value = savedValue;

    let input = form.querySelector(`input[name="attributes[${key}]"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = `attributes[${key}]`;
      form.appendChild(input);
    }
    input.value = select.value;

    select.addEventListener("change", () => handleChange(select, key));
  });
}

const refreshSamples = () => setTimeout(setUpSamples, 500);

window.addEventListener("DOMContentLoaded", setUpSamples);
document.addEventListener("cart:refresh", refreshSamples);
document.addEventListener("cart:change", refreshSamples);*/

/*document.addEventListener("DOMContentLoaded", function() {
  const marquees = document.querySelectorAll('marquee-text');

  const handleVisibility = (entries, observer) => {
    entries.forEach(entry => {
      const scrollerPart = entry.target.shadowRoot.querySelector('[part="scroller"]');
      if (entry.isIntersecting) {
        scrollerPart.style.removeProperty('--transform-logical-flip');
      } else {
        scrollerPart.style.setProperty('--transform-logical-flip', '0');
      }
    });
  };

  const observer = new IntersectionObserver(handleVisibility, {
    threshold: 0.1
  });

  marquees.forEach(marquee => observer.observe(marquee));
});*/

/*
let lastOpenedDetails = null;

document.addEventListener('click', event => {
    const currentDetails = event.target.closest('details');

    // Check if the currentDetails element is within <main> or <footer>
    if (currentDetails && (currentDetails.closest('main') || currentDetails.closest('footer'))) {
        if (lastOpenedDetails && lastOpenedDetails !== currentDetails && lastOpenedDetails.open) {
            lastOpenedDetails.querySelector('summary').click();
        }
        lastOpenedDetails = currentDetails.open ? currentDetails : null;
    }
});*/

/*document.addEventListener("DOMContentLoaded", function() {
    const footer = document.querySelector("footer");
    const footerInner = footer.querySelector(".footer__inner");

    window.addEventListener("scroll", function() {
        const footerRect = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight;
      
        if (footerRect.top <= windowHeight) {
            footer.style.opacity = 1;
            let visibleHeight = Math.min(footerRect.bottom, windowHeight) - footerRect.top;
            let totalFooterHeight = footerRect.height;
            let visiblePercentage = visibleHeight / totalFooterHeight;
            let translateY = 180 * (1 - visiblePercentage);
            translateY = Math.max(0, translateY); 
            let opacity = 1 - (translateY / 180);

            footerInner.style.transform = `translate3d(0, ${translateY}px, 0)`;
            footerInner.style.opacity = opacity;
        } else {
          footer.style.opacity = 0;
        }

        if (footerRect.bottom <= windowHeight) {
            footerInner.style.transform = `translate3d(0, 0, 0)`;
        }
    });
});*/

// Encapsulate the functionality to allow re-initialization
const initializeSelectHandling = () => {
  // Utility function to apply 'added' attributes from session storage to select elements
  const applyAddedAttributes = () => {
    document.querySelectorAll('.sample-select').forEach(selectElement => {
      const selectId = selectElement.id;
      const addedValue = sessionStorage.getItem(selectId);
      if (addedValue) {
        selectElement.setAttribute('added', addedValue);
      }
    });
  };

  // Use event delegation for handling change events on dynamically added '.sample-select' elements
  document.body.addEventListener('change', function(e) {
    if (e.target && e.target.matches('.sample-select')) {
      const selectedValue = e.target.value;
      e.target.setAttribute('added', selectedValue);
      sessionStorage.setItem(e.target.id, selectedValue);

      document.querySelectorAll('.shopify-product-form').forEach(form => {
        const hiddenInput = form.querySelector('input[type="hidden"][name="id"]');
        if (hiddenInput && hiddenInput.value === selectedValue) {
          const submitButton = form.querySelector('button[type="submit"]');
          if (submitButton) {
            submitButton.click();
          }
        }
      });
    }
  });

  // Function to refresh the added attributes
  const refreshSampleAttributes = () => setTimeout(applyAddedAttributes, 1);

  // Apply 'added' attributes initially and on custom events indicating content changes
  refreshSampleAttributes();
  document.addEventListener("DOMContentLoaded", refreshSampleAttributes);
  document.addEventListener("cart:refresh", refreshSampleAttributes);
  document.addEventListener("cart:change", refreshSampleAttributes);
};

// Initialize the script functionality
initializeSelectHandling();

//cursor
/*document.addEventListener("DOMContentLoaded", function () {
  var cursor = document.querySelector('.cursor');
  const a = document.querySelectorAll('a, button:not(disabled), .button, label, summary, [role=button], [type=checkbox], [type=radio], [type=button], a:-webkit-any-link');
  const p = document.querySelectorAll('h1, h2, h3, h4, h5, h6, p, strong, i, input, textarea, .prose, .smallcaps, .mono');
  
  document.addEventListener('mousemove', function(e){
    var x = e.clientX;
    var y = e.clientY;
    cursor.style.left = x + 'px';
    cursor.style.top = y + 'px';
  });
  
  document.addEventListener('mousedown', function(){
    cursor.classList.add('click');
  });
  
  document.addEventListener('mouseup', function(){
    cursor.classList.remove('click')
  });

    
  p.forEach(item => {
    item.addEventListener('mouseover', () => {
      cursor.classList.add('text');
      var fontSize = window.getComputedStyle(item).fontSize;
      cursor.style.height = fontSize;
    });
    item.addEventListener('mouseleave', () => {
      cursor.classList.remove('text');
      cursor.style.height = '';
    });
  });
  
  a.forEach(item => {
    item.addEventListener('mouseover', () => {
      cursor.classList.add('hover');
      //var rect = item.getBoundingClientRect();
      //cursor.style.width = `${rect.width + 18}px`;
      //cursor.style.height = `${rect.height + 9}px`;
      //cursor.style.left = `${rect.left + window.scrollX}px`;
      //cursor.style.top = `${rect.top + window.scrollY}px`;
    });
    item.addEventListener('mouseleave', () => {
      cursor.classList.remove('hover');
      cursor.style.width = '';
      cursor.style.height = '';
      cursor.style.left = '';
      cursor.style.top = '';
    });
  });
});*/

document.addEventListener("DOMContentLoaded", function() {
    const links = document.querySelectorAll('.mega-menu a[data-dynamic-image]');
    const imageContainer = document.querySelector('.dynamic-image-container img');
    if (!imageContainer) {
        return;
    }
    const originalSrc = imageContainer.src;
    
    links.forEach(link => {
        link.addEventListener('mouseover', function() {
            const dynamicImage = this.getAttribute('data-dynamic-image');
            if (dynamicImage && dynamicImage.trim() !== "") {
                imageContainer.style.opacity = 0;
                setTimeout(() => {
                    imageContainer.src = dynamicImage;
                    imageContainer.style.opacity = 1;
                }, 100);
            }
        });

        link.addEventListener('mouseout', function() {
            imageContainer.style.opacity = 0;
            setTimeout(() => {
                imageContainer.src = originalSrc;
                imageContainer.style.opacity = 1;
            }, 100);
        });
    });
});